import React from 'react'
import { Link } from 'react-static'

import { trackedClick } from '../utils'

import Intent from './Intent'

const ModelCards = ({ intents, showMore }) => (
    <div className="model-cards">
        <div className="model-cards__list">
            {(intents || []).map(intent => {
                if (!intent) {
                    return 'no intent'
                }
                return <Intent key={intent.url} intent={intent} />
            })}
            {showMore && (
                <div className="model-cards__item">
                    <Link
                        className="model-card model-card--more"
                        onClick={trackedClick('Go to catalog clicked', {
                            source: 'Main page',
                            title: 'See more intents',
                        })}
                        href="/api-platform/ai"
                        to="/api-platform/ai"
                        title="See more intents"
                    >
                        <div className="model-card__inner">
                            <div className="model-card__more">
                                <div className="model-card__more-icon">...</div>
                                <div className="model-card__more-text">
                                    See more intents
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
            )}
        </div>
    </div>
)

export default ModelCards



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/ModelCards.jsx